import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Brand
      {record ? `: ${record.name}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/CarBrand/Title.js